import Exchange from "../../Transactions/Exchange";
import { Modal } from ".";

export default function ExchangeModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-md">
      <Exchange />
    </Modal>
  );
}